import { render, staticRenderFns } from "./CompetitionsViewFixturesView.vue?vue&type=template&id=be155cd0&"
import script from "./CompetitionsViewFixturesView.vue?vue&type=script&lang=js&"
export * from "./CompetitionsViewFixturesView.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsViewFixturesView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports